import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57d4228f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-parameters-leave_content" }, " Если выйти сейчас, данные не сохранятся ", -1))

import { ref } from "vue";
import {
  TirPmModal,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";

/**Открыто ли окно */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameters-leave',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
/**Колбэк для выхода */
const leaveCallback = ref<Function>();

/**Переключение видимости окна */
const toggle = (_visible: boolean, callback?: Function) => {
  visible.value = _visible;
  leaveCallback.value = _visible ? callback : undefined;
};
/**Подтверждение выхода */
const confirmLeave = () => {
  leaveCallback.value?.();
  toggle(false);
};

/**Код для использования по ref */
__expose({ toggle });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    class: "task-parameters-leave",
    title: "Выйти сейчас?",
    "is-with-back": false,
    "is-visible": visible.value,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (toggle(false)))
  }, {
    content: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Вернуться ")
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: confirmLeave
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Выйти ")
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})